module.exports = __webpack_public_path__ + "static/media/trophy.e2953e34.svg";